import LinkButton from "@components/buttons/LinkButton"
import Helmet from "@components/Helmet"
import Layout from "@components/Layout"
import breakpoints from "@constants/breakpoints"
import { h2Styles, h3Styles, h4Styles } from "@constants/typography"
import { DesktopOnly, MobileAndTabletOnly } from "@utils/MediaQuery"
import React from "react"
import styled from "styled-components"

const Container = styled.main`
  padding-top: 48px;
  padding-bottom: 48px;

  @media ${breakpoints.tablet} {
    padding-top: calc(1 / 12 * 100vw);
    padding-bottom: calc(2 / 12 * 100vw);
  }

  @media ${breakpoints.laptop} {
    padding-top: calc(1 / 12 * 100vw);
    padding-bottom: calc(2 / 12 * 100vw);
  }
`

const Content = styled.div`
  padding: 0 20px;

  @media ${breakpoints.laptop} {
    padding: 0 calc(1 / 12 * 100vw);
  }

  @media ${breakpoints.desktop} {
    padding: 0 calc(1 / 12 * 100vw);
  }
`

const Header = styled.h2`
  ${h4Styles}
  flex-direction: column;
  display: flex;
  margin-bottom: 48px;

  @media ${breakpoints.laptop} {
    ${h3Styles}
    margin-bottom: 55px;
  }

  @media ${breakpoints.desktop} {
    ${h2Styles}
    margin-bottom: 55px;
  }
`

const MobileHeaderRow = styled.span`
  margin-bottom: 4px;
`

const LinkWrapper = styled.div`
  width: 220px;

  margin-top: 48px;

  @media ${breakpoints.laptop} {
    ${h3Styles}
    margin-top: 55px;
  }

  @media ${breakpoints.desktop} {
    ${h2Styles}
    margin-top: 55px;
  }
`

const NotFoundPage = ({ location }) => (
  <Layout location={location}>
    <Helmet title="404: Page Not found" />
    <Container>
      <Content>
        <MobileAndTabletOnly>
          <Header>
            <MobileHeaderRow>404</MobileHeaderRow>
            <MobileHeaderRow>Page Not Found</MobileHeaderRow>
          </Header>
        </MobileAndTabletOnly>
        <DesktopOnly>
          <Header>404 Page Not Found</Header>
          <div data-popmechanic-embed="53403" />
        </DesktopOnly>
        <LinkWrapper>
          <LinkButton text="Back to Home" to="/" />
        </LinkWrapper>
      </Content>
    </Container>
  </Layout>
)

export default NotFoundPage
